import { render, staticRenderFns } from "./SupplierProductTab.vue?vue&type=template&id=2836ab2e&"
import script from "./SupplierProductTab.vue?vue&type=script&lang=js&"
export * from "./SupplierProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports